// @flow
import * as React from "react"
import {
  InstantSearch,
  Hits,
  SearchBox,
  Highlight,
} from "react-instantsearch-dom"
import { AngoliaSearch } from "./AngoliaSearch"

export { SearchBox, Hits, Highlight, AngoliaSearch }

export type tProps = {
  children: React.Node,
}

export type tState = {
  setIsActive: (isActive?: boolean) => void,
  isActive: boolean,
}

export const initialState = {
  // eslint-disable-next-line
  setIsActive: (isActive?: boolean) => {},
  isActive: false,
}

export const { Provider, Consumer } = React.createContext(initialState)

export class AngoliaSearchContainer extends React.Component<tProps, tState> {
  // requiredEnvironmentVariables = [
  //   {
  //     name: "ALGOLIA_SEARCH_ONLY_KEY",
  //     value: process.env.ALGOLIA_SEARCH_ONLY_KEY,
  //   },
  //   {
  //     name: "ALGOLIA_APP_ID",
  //     value: process.env.ALGOLIA_APP_ID,
  //   },
  //   {
  //     name: "ALGOLIA_SEARCH_INDEX",
  //     value: process.env.ALGOLIA_SEARCH_INDEX,
  //   },
  // ]
  // constructor(props: tProps) {
  //   super(props)

  //   this.requiredEnvironmentVariables.map((item) => {
  //     if (typeof item.value === undefined)
  //       // eslint-disable-next-line no-console
  //       console.error(
  //         `'${
  //           item.name
  //         }' environment variable was NOT found. This is required for AngoliaSearch`,
  //       )
  //   })
  // }
  setIsActive = (isActive?: boolean) => {
    if (typeof isActive !== "undefined") {
      this.setState({ isActive })
    } else {
      this.setState((st) => ({ isActive: !st.isActive }))
    }
  }
  closeOverlay = () => this.setState({ isActive: false })
  state = {
    ...initialState,
    setIsActive: this.setIsActive,
    isActive: false,
  }
  render() {
    return (
      <InstantSearch
        appId={"URUS7LTBA1"}
        apiKey={"9b35573cad995984da873e106ae89f57"}
        indexName={"Center for Spiritual Living"}
      >
        <Provider value={this.state}>{this.props.children}</Provider>
      </InstantSearch>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/AlgoliaSearch/index.js